import {applyMiddleware, combineReducers, createStore} from "redux";
import thunkMiddleWare  from "redux-thunk"
import authReducer from "./auth-reducer"
import {reducer as formReducer} from 'redux-form'
import advReducer from "./adv-reducer";
import advViewReducer from './advView-reducer'
import appReducer from "./app-reducer";



const reducers = combineReducers({
    app:appReducer,
    advView: advViewReducer,
    adv:advReducer,
    auth: authReducer,
    form: formReducer
});

const store = createStore(reducers, applyMiddleware(thunkMiddleWare));

window.store = store;

export default store;